import React from 'react'

import './campaign-allocation.css'
import { Link } from 'react-router-dom'

const Test1 = (props) => {
    return (
        <div className="home-links1">
            <div className="campaign-allocation-main">
                <div className="campaign-allocation-content">
                    <h1 className="campaign-allocation-heading">Test1 View</h1>
                    <div className="campaign-allocation-container1">
                        <div className="home-links1">
                            <Link to="/" className="home-link navLink">
                                Home
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Test1
